import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconAnimation, IconBeachAccess, IconFitnessCenter, IconHotelFront, IconLeaf, IconPersonPlay, IconPool, IconRestaurant, IconRoom, IconSailing, IconSpa } from '@travel-frontend/icons';
const iconMapping = {
  // Mapping for S3 JSON
  type: IconHotelFront,
  hotel: IconHotelFront,
  wellness: IconSpa,
  children: IconPersonPlay,
  eco: IconLeaf,
  pool: IconPool,
  beach: IconBeachAccess,
  sports: IconFitnessCenter,
  'water sports': IconSailing,
  'restaurants/food': IconRestaurant,
  animation: IconAnimation,
  near: IconRoom,
  // Mapping for Hotel Content API
  'IT03-TYPE': IconHotelFront,
  'IT03-HOT': IconHotelFront,
  'IT03-WELL': IconSpa,
  'IT03-CHI': IconPersonPlay,
  'IT03-POOL': IconPool,
  'IT03-BEA': IconBeachAccess,
  'IT03-SPO': IconFitnessCenter,
  'IT03-WSPO': IconSailing,
  'IT03-REST': IconRestaurant,
  'IT03-ANI': IconAnimation,
  'IT03-NEA': IconRoom
};
export const SectionIcon = /*#__PURE__*/_styled(({
  name,
  ...restProps
}) => {
  const Icon = iconMapping[name] ?? null;
  if (!Icon) {
    return null;
  }
  return _jsx(Icon, {
    ...restProps
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1exbiy40"
} : {
  target: "e1exbiy40",
  label: "SectionIcon"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb25JY29uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9DRyIsImZpbGUiOiJTZWN0aW9uSWNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJY29uQW5pbWF0aW9uLCBJY29uQmVhY2hBY2Nlc3MsIEljb25GaXRuZXNzQ2VudGVyLCBJY29uSG90ZWxGcm9udCwgSWNvbkxlYWYsIEljb25QZXJzb25QbGF5LCBJY29uUG9vbCwgSWNvblJlc3RhdXJhbnQsIEljb25Sb29tLCBJY29uU2FpbGluZywgSWNvblNwYSwgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2ljb25zJztcbmNvbnN0IGljb25NYXBwaW5nID0ge1xuICAgIC8vIE1hcHBpbmcgZm9yIFMzIEpTT05cbiAgICB0eXBlOiBJY29uSG90ZWxGcm9udCxcbiAgICBob3RlbDogSWNvbkhvdGVsRnJvbnQsXG4gICAgd2VsbG5lc3M6IEljb25TcGEsXG4gICAgY2hpbGRyZW46IEljb25QZXJzb25QbGF5LFxuICAgIGVjbzogSWNvbkxlYWYsXG4gICAgcG9vbDogSWNvblBvb2wsXG4gICAgYmVhY2g6IEljb25CZWFjaEFjY2VzcyxcbiAgICBzcG9ydHM6IEljb25GaXRuZXNzQ2VudGVyLFxuICAgICd3YXRlciBzcG9ydHMnOiBJY29uU2FpbGluZyxcbiAgICAncmVzdGF1cmFudHMvZm9vZCc6IEljb25SZXN0YXVyYW50LFxuICAgIGFuaW1hdGlvbjogSWNvbkFuaW1hdGlvbixcbiAgICBuZWFyOiBJY29uUm9vbSxcbiAgICAvLyBNYXBwaW5nIGZvciBIb3RlbCBDb250ZW50IEFQSVxuICAgICdJVDAzLVRZUEUnOiBJY29uSG90ZWxGcm9udCxcbiAgICAnSVQwMy1IT1QnOiBJY29uSG90ZWxGcm9udCxcbiAgICAnSVQwMy1XRUxMJzogSWNvblNwYSxcbiAgICAnSVQwMy1DSEknOiBJY29uUGVyc29uUGxheSxcbiAgICAnSVQwMy1QT09MJzogSWNvblBvb2wsXG4gICAgJ0lUMDMtQkVBJzogSWNvbkJlYWNoQWNjZXNzLFxuICAgICdJVDAzLVNQTyc6IEljb25GaXRuZXNzQ2VudGVyLFxuICAgICdJVDAzLVdTUE8nOiBJY29uU2FpbGluZyxcbiAgICAnSVQwMy1SRVNUJzogSWNvblJlc3RhdXJhbnQsXG4gICAgJ0lUMDMtQU5JJzogSWNvbkFuaW1hdGlvbixcbiAgICAnSVQwMy1ORUEnOiBJY29uUm9vbSxcbn07XG5leHBvcnQgY29uc3QgU2VjdGlvbkljb24gPSBzdHlsZWQoKHsgbmFtZSwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICBjb25zdCBJY29uID0gaWNvbk1hcHBpbmdbbmFtZV0gPz8gbnVsbDtcbiAgICBpZiAoIUljb24pIHtcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuICAgIHJldHVybiBfanN4KEljb24sIHsgLi4ucmVzdFByb3BzIH0pO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1TZWN0aW9uSWNvbi5qcy5tYXAiXX0= */");